<template>
  <div class="layout">
    <Header></Header>
    <div class="content">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './header'
import BindhtmlFontSize from '../mixin/bindhtmlFontSize'
import Footer from './footer'
export default {
  props: {},
  mixins: [BindhtmlFontSize],
  components: { Header, Footer },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped></style>
